<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<nz-spin [nzSpinning]="loading">
  <div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
    <div class="flex flex-row justify-end gap-3">
      <button nz-button nzType="primary" (click)="navigateToCreatePlanPage()">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
        Add new Plan
      </button>
      <button nz-button nzType="primary" (click)="showLinkingModalFn()">
        <span nz-icon nzType="link" nzTheme="outline"></span>
        Associate Plan
      </button>
    </div>
    <div class="p-4">
      <div *ngFor="let vertical of plansMapped; let i = index" class="mb-8">
        <div class="flex justify-between items-center">
          <div
            class="text-xl font-bold mb-2 flex items-center w-full justify-between bg-gray-200 p-3 rounded-md cursor-pointer hover:bg-gray-300 transition"
            (click)="toggleVertical(i, vertical.verticalId)"
          >
            {{ vertical.verticalName }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 transform transition-transform"
              [ngClass]="{ 'rotate-180': isVerticalOpen[i] }"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1.707-10.293a1 1 0 00-1.414 0L10 8.586 8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 000-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="w-20 flex justify-center items-center">
            <button
              (click)="showUpdateVertical(vertical.verticalId)"
              nz-button
              nzShape="circle"
            >
              <span nz-icon nzType="edit" nzTheme="outline"></span>
            </button>
          </div>
        </div>
        <div *ngIf="isVerticalOpen[i]" class="pl-4">
          <div
            *ngFor="let concern of vertical.concerns; let j = index"
            class="mb-4"
          >
            <div class="flex justify-evenly">
              <div
                class="text-lg font-semibold mb-2 flex items-center w-10/12 justify-between bg-blue-100 p-3 rounded-md cursor-pointer hover:bg-blue-200 transition"
                (click)="toggleConcern(i, j)"
              >
                {{ concern.concernName }}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 transform transition-transform"
                  [ngClass]="{ 'rotate-180': isConcernOpen[i][j] }"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm1.707-10.293a1 1 0 00-1.414 0L10 8.586 8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 000-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="w-20 flex justify-center items-center">
                <button
                  (click)="showUpdateConcern(concern.concernId)"
                  nz-button
                  nzShape="circle"
                >
                  <span nz-icon nzType="edit" nzTheme="outline"></span>
                </button>
              </div>
            </div>
            <div
              *ngIf="isConcernOpen[i][j]"
              class="pl-4 flex overflow-x-auto space-x-4"
            >
              <div
                *ngFor="let plan of concern.plans"
                class="w-96 flex-shrink-0 p-4 border rounded-lg"
              >
                <div class="mb-2">
                  <img
                    *ngIf="plan.planImage"
                    [src]="plan.planImage"
                    alt="Plan Image"
                    class="w-full h-32 object-cover rounded-lg"
                  />
                </div>
                <div class="text-lg font-bold">Name : {{ plan.planName }}</div>
                <div class="text-lg font-bold">
                  Internal Name : {{ plan.internalPlanName }}
                </div>
                <div class="text-sm text-gray-600">
                  {{ plan.planDescription }}
                </div>
                <div class="mt-2">
                  <div>
                    <strong>Validity Days:</strong> {{ plan.validityDays }}
                  </div>
                  <div>
                    <strong>No of Sessions:</strong> {{ plan.noOfSessions }}
                  </div>
                  <div>
                    <strong>Per Session Timing:</strong>
                    {{ plan.perSessionTimeInMin }}
                  </div>

                  <div><strong>Charges:</strong></div>
                  <div class="ml-4">
                    <div *ngFor="let level of expertLevelArray">
                      <strong class="font-extrabold"
                        >{{ expertLevelMap[level] }} : </strong
                      >{{ plan.charges![level][0].currencySymbol
                      }}{{ plan.charges![level][0].amount }}
                    </div>
                  </div>
                </div>
                <br />
                <div class="flex flex-grow">
                  <button
                    class="w-full"
                    (click)="
                      unLinkPlan(
                        vertical.verticalId,
                        concern.concernId,
                        plan.id
                      )
                    "
                    nz-button
                    nzType="primary"
                    nzDanger
                  >
                    Un-Link
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-center my-8">
            <span
              nz-tooltip
              (click)="showAddConcern(vertical.verticalId)"
              [nzTooltipTitle]="'Add Concern in ' + vertical.verticalName"
              class="scale-[3] mx-auto"
              nz-icon
              nzType="plus-circle"
              nzTheme="outline"
            ></span>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-center min-h-fit">
        <span
          *ngIf="!pageLoading && !verticalOpen"
          nz-tooltip
          nzTooltipTitle="Add Vertical"
          (click)="showAddVertical()"
          class="scale-[3] mx-auto"
          nz-icon
          nzType="plus-circle"
          nzTheme="outline"
        ></span>
      </div>
    </div>
  </div>
</nz-spin>
<nz-modal
  [(nzVisible)]="showLinkingModal"
  nzTitle="Link Plans"
  (nzOnCancel)="handleLinkingModalCancel()"
  (nzOnOk)="handleLinkingModalOk()"
>
  <ng-container *nzModalContent>
    <div class="flex flex-row w-full gap-3">
      <div>
        <span>Select Vertical</span>
        <nz-select
          nzPlaceHolder="Select Vertical"
          class="flex-col min-w-[200px]"
          [ngModel]="selectedVertical"
          (ngModelChange)="selectedVerticalFn($event)"
        >
          <nz-option
            *ngFor="let item of verticals"
            [nzValue]="item.id"
            [nzLabel]="item.name"
          ></nz-option>
        </nz-select>
      </div>
      <div>
        <span>Select Concerns</span>
        <nz-select
          nzPlaceHolder="Select Concerns"
          class="flex-col min-w-[200px]"
          nzMode="multiple"
          [ngModel]="selectedConcern"
          (ngModelChange)="selectedConcernsFn($event)"
        >
          <nz-option
            *ngFor="let item of concernsFiltered"
            [nzValue]="item.id"
            [nzLabel]="item.name"
          ></nz-option>
        </nz-select>
      </div>
    </div>
    <br />
    <div class="flex flex-row w-full gap-3">
      <!-- <div> -->
      <nz-select
        class="flex-col w-full"
        [ngModel]="selectedPlan"
        nzMode="multiple"
        (ngModelChange)="selectedPlansFn($event)"
      >
        <nz-option
          nzPlaceHolder="Select Plan"
          *ngFor="let item of activePlans"
          [nzValue]="item.id"
          [nzLabel]="item.planName + ' (' + item.internalPlanName + ')'"
        ></nz-option>
      </nz-select>
      <!-- </div> -->
    </div>
  </ng-container>
</nz-modal>
<nz-drawer
  [nzVisible]="isVisible"
  [nzWidth]="520"
  nzPlacement="right"
  [nzTitle]="(isEditVertical ? 'Edit' : 'Add') + ' Vertical'"
  (nzOnClose)="handleCancel()"
  [nzClosable]="true"
>
  <ng-container *nzDrawerContent>
    <div class="flex flex-col gap-4 pb-6">
      <section class="rounded-lg border border-gray-200 p-4 bg-gray-50/50">
        <h4 class="text-base font-bold text-gray-800 mb-3">Appearance</h4>
        <div class="flex flex-col gap-3">
          <div>
            <label class="form-label required font-bold">Vertical Name</label>
            <input
              class="w-full mt-1"
              [(ngModel)]="verticalName"
              nz-input
              nzSize="large"
              placeholder="Enter Name"
            />
          </div>
          <div>
            <label class="form-label required font-bold">Vertical Image</label>
            <img
              *ngIf="verticalImageUrl"
              class="w-14 h-14 object-cover rounded mb-2 mt-1"
              [src]="verticalImageUrl"
              alt="vertical-image"
            />
            <input
              class="w-full mt-1"
              (change)="uploadVerticalImage($event)"
              nz-input
              accept=".jpg,.jpeg,.png"
              nzSize="large"
              type="file"
              placeholder="Enter vertical Image"
            />
          </div>
          <div>
            <label class="form-label required font-bold">Primary Color</label>
            <input
              class="w-full h-10 mt-1"
              [(ngModel)]="primaryColor"
              nz-input
              nzSize="large"
              type="color"
            />
          </div>
          <div>
            <label class="form-label required font-bold">Secondary Color</label>
            <input
              class="w-full h-10 mt-1"
              [(ngModel)]="secondaryColor"
              nz-input
              nzSize="large"
              type="color"
            />
          </div>
          <div>
            <label class="form-label font-bold mb-2 block">Card Preview</label>
            <div
              class="relative p-4 rounded-2xl overflow-hidden"
              [ngStyle]="{ 'background-color': primaryColor || '#E5E7EB' }"
            >
              <div class="flex flex-wrap gap-2 mb-3">
                <span
                  class="px-3 py-1 rounded-full text-xs font-medium text-gray-800"
                  [ngStyle]="{
                    'background-color': secondaryColor || '#FFFFFF'
                  }"
                >
                  {{ verticalName || "Vertical Name" }}
                </span>
                <span
                  class="px-3 py-1 rounded-full text-xs font-medium text-gray-800"
                  [ngStyle]="{
                    'background-color': secondaryColor || '#FFFFFF'
                  }"
                >
                  Concern Name
                </span>
              </div>
              <div class="text-base font-semibold text-gray-700 mb-2">
                Plan Name
              </div>
              <div class="flex items-center gap-2 mb-1 text-sm text-gray-600">
                <span nz-icon nzType="user" nzTheme="outline"></span>
                <span>Purchased on: 21/08/26</span>
              </div>
              <div class="flex items-center gap-2 mb-1 text-sm text-gray-600">
                <span nz-icon nzType="calendar" nzTheme="outline"></span>
                <span>Valid till: 21/08/27</span>
              </div>
              <div class="flex items-center gap-2 mb-1 text-sm text-gray-600">
                <span nz-icon nzType="user" nzTheme="outline"></span>
                <span>Therapist Name</span>
              </div>
              <span
                nz-icon
                nzType="arrow-right"
                nzTheme="outline"
                class="absolute right-6 bottom-6 text-lg text-gray-800"
              ></span>
            </div>
            <p class="mt-2 text-xs text-red-600 font-medium">
              * Note: This is a preview of how the card will appear in the app.
            </p>
          </div>
        </div>
      </section>

      <section class="rounded-lg border border-gray-200 p-4 bg-gray-50/50">
        <h4 class="text-base font-bold text-gray-800 mb-3">Conditions</h4>
        <div class="flex flex-col gap-3">
          <div class="flex items-center justify-between">
            <span class="flex items-center gap-1">
              <label class="form-label font-bold mb-0">Is Visible</label>
              <span
                nz-tooltip
                nzTooltipTitle="Whether this vertical is visible to users"
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </span>
            <nz-switch [(ngModel)]="isVerticalVisible"></nz-switch>
          </div>
          <div class="flex items-center justify-between">
            <span class="flex items-center gap-1">
              <label class="form-label font-bold mb-0">Is Health Program</label>
              <span
                nz-tooltip
                nzTooltipTitle="If enabled, this vertical is used for Health Program tab experiences"
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </span>
            <nz-switch [(ngModel)]="isHealthProgram"></nz-switch>
          </div>
          <div>
            <label class="form-label font-bold">Description</label>
            <textarea
              class="w-full mt-1"
              [(ngModel)]="verticalDescription"
              nz-input
              nzSize="large"
              rows="4"
              maxlength="500"
              placeholder="Enter description for this vertical"
            ></textarea>
          </div>
          <div class="flex items-center justify-between">
            <span class="flex items-center gap-1">
              <label class="form-label font-bold mb-0"
                >User Select Session Duration</label
              >
              <span
                nz-tooltip
                nzTooltipTitle="Allow user to choose session duration"
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </span>
            <nz-switch [(ngModel)]="userSelectSessionDuration"></nz-switch>
          </div>

          <div>
            <div class="flex items-center gap-1 mb-2">
              <label class="form-label font-bold mb-0"
                >Not applicable to partners</label
              >
              <span
                nz-tooltip
                nzTooltipTitle="Partners selected here will not see this vertical. Partners in Session intervals are excluded from this list."
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </div>
            <nz-spin [nzSpinning]="partnersLoading">
              <nz-select
                class="w-full"
                nzMode="multiple"
                nzPlaceHolder="Select partners to exclude"
                [(ngModel)]="notApplicablePartnerIdsVertical"
                [nzLoading]="partnersLoading"
                nzShowSearch
                nzAllowClear
              >
                <nz-option
                  *ngFor="let p of partnerList"
                  [nzValue]="p.partnerId"
                  [nzLabel]="p.partner"
                ></nz-option>
              </nz-select>
            </nz-spin>
          </div>

          <div>
            <div class="flex items-center gap-1 mb-2">
              <label class="form-label font-bold mb-0"
                >Session intervals by partner</label
              >
              <span
                nz-tooltip
                nzTooltipTitle="Set session interval (minutes) per partner. Default applies to all others. Partners in Not applicable to partners are excluded from this list."
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </div>
            <div class="flex flex-col gap-2">
              <div
                *ngFor="let row of sessionIntervalsVertical; let i = index"
                class="flex flex-wrap items-center gap-2"
              >
                <ng-container *ngIf="row.key === 'default'">
                  <span class="w-24 form-label font-bold">Default</span>
                  <input
                    type="number"
                    nz-input
                    class="flex-1 min-w-[80px]"
                    [(ngModel)]="row.value"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </ng-container>
                <ng-container *ngIf="row.key !== 'default'">
                  <nz-select
                    class="w-40"
                    [(ngModel)]="row.key"
                    [ngModelOptions]="{ standalone: true }"
                    nzPlaceHolder="Partner"
                    nzAllowClear
                  >
                    <nz-option
                      *ngFor="
                        let p of getPartnersForSessionIntervalsVertical(
                          getUsedPartnerKeysVerticalExcluding(row.key)
                        )
                      "
                      [nzValue]="p.partnerId"
                      [nzLabel]="p.partner"
                    ></nz-option>
                  </nz-select>
                  <input
                    type="number"
                    nz-input
                    class="flex-1 min-w-[80px]"
                    [(ngModel)]="row.value"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <button
                    nz-button
                    nzType="text"
                    nzDanger
                    (click)="removeSessionIntervalRowVertical(i)"
                  >
                    <span nz-icon nzType="minus" nzTheme="outline"></span>
                  </button>
                </ng-container>
              </div>
              <button
                nz-button
                nzType="dashed"
                nzSize="small"
                (click)="addSessionIntervalRowVertical()"
              >
                <span nz-icon nzType="plus" nzTheme="outline"></span>
                Add partner interval
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="flex justify-end gap-2 mt-4 pt-4 border-t">
      <button nz-button (click)="handleCancel()">Cancel</button>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="isOkLoading"
        (click)="addNewVertical()"
      >
        Save
      </button>
    </div>
  </ng-container>
</nz-drawer>
<nz-drawer
  [nzVisible]="isVisibleConcern"
  [nzWidth]="520"
  nzPlacement="right"
  [nzTitle]="(isEditConcern ? 'Edit' : 'Add') + ' Concern'"
  (nzOnClose)="handleConcernCancel()"
  [nzClosable]="true"
>
  <ng-container *nzDrawerContent>
    <div class="flex flex-col gap-4 pb-6">
      <section class="rounded-lg border border-gray-200 p-4 bg-gray-50/50">
        <h4 class="text-base font-bold text-gray-800 mb-3">Appearance</h4>
        <div class="flex flex-col gap-3">
          <div>
            <label class="form-label required font-bold">Concern name</label>
            <input
              class="w-full mt-1"
              [(ngModel)]="concernName"
              nz-input
              nzSize="large"
              placeholder="Enter Concern Name"
            />
          </div>
          <div>
            <label class="form-label font-bold">Concern Image</label>
            <img
              *ngIf="concernImageUrl"
              class="w-14 h-14 object-cover rounded mb-2 mt-1"
              [src]="concernImageUrl"
              alt="concern-image"
            />
            <input
              class="w-full mt-1"
              (change)="uploadConcernImage($event)"
              nz-input
              accept=".jpg,.jpeg,.png"
              nzSize="large"
              type="file"
              placeholder="Enter concern image"
            />
          </div>
        </div>
      </section>

      <section class="rounded-lg border border-gray-200 p-4 bg-gray-50/50">
        <h4 class="text-base font-bold text-gray-800 mb-3">Conditions</h4>
        <div class="flex flex-col gap-3">
          <div>
            <label class="form-label font-bold">Description</label>
            <textarea
              class="w-full mt-1"
              [(ngModel)]="concernDescription"
              nz-input
              nzSize="large"
              rows="4"
              maxlength="500"
              placeholder="Enter description for this concern"
            ></textarea>
          </div>
          <div>
            <label class="form-label font-bold">Expertise Tagline</label>
            <nz-select
              class="w-full"
              nzPlaceHolder="Select expertise tagline"
              [(ngModel)]="expertiseTagline"
              nzShowSearch
              nzAllowClear
            >
              <nz-option
                *ngFor="let item of masterData.therapyPackExpertise || []"
                [nzValue]="item.data"
                [nzLabel]="item.data"
              ></nz-option>
            </nz-select>
          </div>
          <div class="flex items-center justify-between">
            <span class="flex items-center gap-1">
              <label class="form-label font-bold mb-0">Is Visible</label>
              <span
                nz-tooltip
                nzTooltipTitle="Whether this concern is visible to users"
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </span>
            <nz-switch [(ngModel)]="isConcernVisible"></nz-switch>
          </div>
          <div class="flex items-center justify-between">
            <span class="flex items-center gap-1">
              <label class="form-label font-bold mb-0"
                >User Select Session Duration</label
              >
              <span
                nz-tooltip
                nzTooltipTitle="Allow user to choose session duration"
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </span>
            <nz-switch
              [(ngModel)]="userSelectSessionDurationConcern"
            ></nz-switch>
          </div>

          <div>
            <div class="flex items-center gap-1 mb-2">
              <label class="form-label font-bold mb-0"
                >Not applicable to partners</label
              >
              <span
                nz-tooltip
                nzTooltipTitle="Partners selected here will not see this concern. Partners in Session intervals are excluded from this list."
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </div>
            <nz-spin [nzSpinning]="partnersLoading">
              <nz-select
                class="w-full"
                nzMode="multiple"
                nzPlaceHolder="Select partners to exclude"
                [(ngModel)]="notApplicablePartnerIdsConcern"
                [nzLoading]="partnersLoading"
                nzShowSearch
                nzAllowClear
              >
                <nz-option
                  *ngFor="let p of partnerList"
                  [nzValue]="p.partnerId"
                  [nzLabel]="p.partner"
                ></nz-option>
              </nz-select>
            </nz-spin>
          </div>

          <div>
            <div class="flex items-center gap-1 mb-2">
              <label class="form-label font-bold mb-0"
                >Session intervals by partner</label
              >
              <span
                nz-tooltip
                nzTooltipTitle="Set session interval (minutes) per partner. Default applies to all others. Partners in Not applicable to partners are excluded from this list."
                class="cursor-help inline-flex"
              >
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              </span>
            </div>
            <div class="flex flex-col gap-2">
              <div
                *ngFor="let row of sessionIntervalsConcern; let i = index"
                class="flex flex-wrap items-center gap-2"
              >
                <ng-container *ngIf="row.key === 'default'">
                  <span class="w-24 form-label font-bold">Default</span>
                  <input
                    type="number"
                    nz-input
                    class="flex-1 min-w-[80px]"
                    [(ngModel)]="row.value"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </ng-container>
                <ng-container *ngIf="row.key !== 'default'">
                  <nz-select
                    class="w-40"
                    [(ngModel)]="row.key"
                    [ngModelOptions]="{ standalone: true }"
                    nzPlaceHolder="Partner"
                    nzAllowClear
                  >
                    <nz-option
                      *ngFor="
                        let p of getPartnersForSessionIntervalsConcern(
                          getUsedPartnerKeysConcernExcluding(row.key)
                        )
                      "
                      [nzValue]="p.partnerId"
                      [nzLabel]="p.partner"
                    ></nz-option>
                  </nz-select>
                  <input
                    type="number"
                    nz-input
                    class="flex-1 min-w-[80px]"
                    [(ngModel)]="row.value"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <button
                    nz-button
                    nzType="text"
                    nzDanger
                    (click)="removeSessionIntervalRowConcern(i)"
                  >
                    <span nz-icon nzType="minus" nzTheme="outline"></span>
                  </button>
                </ng-container>
              </div>
              <button
                nz-button
                nzType="dashed"
                nzSize="small"
                (click)="addSessionIntervalRowConcern()"
              >
                <span nz-icon nzType="plus" nzTheme="outline"></span>
                Add partner interval
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="flex justify-end gap-2 mt-4 pt-4 border-t">
      <button nz-button (click)="handleConcernCancel()">Cancel</button>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="isConcernOkLoading"
        (click)="addNewConcern()"
      >
        Save
      </button>
    </div>
  </ng-container>
</nz-drawer>
